import React, { useState } from 'react'
import { Segment, Grid, Button, Icon } from 'semantic-ui-react'

const WeightDisplay = (props) => {

  const [loadingState, setLoadingState] = useState(0);

  const callback = (shouldPrint, hasCorrectContent) => {
    setLoadingState(1)
    props.resetWeightCallback(shouldPrint, hasCorrectContent).then(() => setLoadingState(2))
  }

  return (
    <Segment size='large'>
      <Grid >
        {
          props.currentBox.hasRX === true ?
            <Grid.Row><Grid.Column><p className={"no-img-warning-label"}>Du måste öppna paketet. Innehåller RX.</p></Grid.Column></Grid.Row>
          : props.imageFound === false ?
            <Grid.Row><Grid.Column><p className={"no-img-warning-label"}>Du måste öppna paketet. Kunde inte ladda bild.</p></Grid.Column></Grid.Row>
          : ""
        }
        <Grid.Row columns={2}>
          <Grid.Column>Beräknad vikt: {props.shippingWeight} g.</Grid.Column>
          <Grid.Column>Uppmätt vikt: {props.iPackMeasuredWeight} g.</Grid.Column>
        </Grid.Row>
        {props.validationResult === 2 ?
          <Grid.Row columns={1}>
            <Grid.Column>
              <Button
                className={"correct-content"}
                onClick={() => callback(true,true)}
                size='medium'
                color='teal'>
                Innehållet stämmer /<br />Skriv ut etikett
              </Button>
                <Button
                    className={`correct-content ${ props.imageFound && !props.currentBox.hasRX ? '' : 'disabled'}`}
                    onClick={() => callback(false,true)}
                    size='medium'
                    color='teal'>
                    Innehållet stämmer
                </Button>
              <Button
                  className={"correct-content"}
                  onClick={() => callback(true,false)}
                  size='medium'
                  color='orange'>
                  Innehållet stämmer inte /<br />Skriv ut etikett
              </Button>
              <div className={"loader-check"}>
                <Icon name={"spinner"} color={"black"} style={loadingState !== 1 ? { display: "none" } : {}} />
                <Icon name={"checkmark"} color={"green"} style={loadingState !== 2 ? { display: "none" } : {}} />
              </div>
            </Grid.Column>
          </Grid.Row>
          : ""}

      </Grid>
    </Segment>
  );
}
export default WeightDisplay;